import { useEffect, useState, useMemo } from 'react';
import polyline from '@mapbox/polyline';

export const useDecodedPolyline = (encodedRoute) => {
    const [path, setPath] = useState([]);

    useEffect(() => {
        if (!encodedRoute || typeof encodedRoute !== 'string') {
            setPath([]);
            return;
        }

        try {
            const decoded = polyline.decode(encodedRoute);

            const coordinates = decoded.map(([lat, lng]) => ({
                lat,
                lng,
            }));

            setPath(coordinates);
        } catch (error) {
            console.error('Error decodificando polyline', error);
            setPath([]);
        }
    }, [encodedRoute]);
   
    return { path };
};
